import { Grid } from '@mui/material'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import {
  DragDropContext,
  DraggableLocation,
  DragStart,
  DropResult,
  ResponderProvided,
} from 'react-beautiful-dnd'
import { EquipmentPlanningUIStore } from '../../stores/equipment-planning-ui-store'
import { EquipmentPlanningAvailableEquipmentsContainer } from '../organisms/EquipmentPlanningAvailableEquipmentsContainer'
import { EquipmentPlanningWorkAreaEquipmentsContainer } from '../organisms/EquipmentPlanningWorkAreaEquipmentsContainer'

interface Props {
  equipmentPlanningUIStore: EquipmentPlanningUIStore
}
export const EquipmentPlanningContent = observer(({ equipmentPlanningUIStore }: Props) => {
  const theme = useMinimalsTheme()

  const handleDragStart = (start: DragStart) => {
    const id = +start.draggableId.split('_')[1]
    equipmentPlanningUIStore.equipmentPlanningEquipmentsUIStore.startDragging(id)
  }

  const handleDragEnd = (result: DropResult, _provided?: ResponderProvided) => {
    const destination: DraggableLocation | undefined | null = result.destination
    const origin: DraggableLocation | undefined | null = result.source
    const previousWorkAreaId: number | null = origin ? +origin.droppableId.substring(3) : null
    const newWorkAreaId: number | null = destination ? +destination.droppableId.substring(3) : null
    const isCancelled = result.reason === 'CANCEL'

    equipmentPlanningUIStore.equipmentPlanningEquipmentsUIStore.endDragging(
      isCancelled,
      newWorkAreaId === 0 ? null : newWorkAreaId, // for unassigned column droppableId is 0
      previousWorkAreaId === 0 ? null : previousWorkAreaId,
      destination?.index,
    )
  }

  return (
    <DragDropContext onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
      <Grid
        container
        columnSpacing={3}
        rowSpacing={2}
        sx={{ minHeight: '70vh', padding: theme.customSpacing.m }}
      >
        <Grid
          sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}
          size={{
            xs: 12,
            md: 3,
          }}
        >
          <EquipmentPlanningAvailableEquipmentsContainer
            uiStore={equipmentPlanningUIStore.equipmentPlanningEquipmentsUIStore}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 9,
          }}
        >
          <EquipmentPlanningWorkAreaEquipmentsContainer
            uiStore={equipmentPlanningUIStore.equipmentPlanningEquipmentsUIStore}
          ></EquipmentPlanningWorkAreaEquipmentsContainer>
        </Grid>
      </Grid>
    </DragDropContext>
  )
})
